import { HeaderLogo } from "./header-logo";
import { HeaderSearch } from "./header-search";

export function Header() {
  return (
    <header
      data-slot="layout-header"
      className="flex items-stretch fixed z-10 top-0 start-0 end-0 shrink-0 bg-background border-b border-border h-(--header-height) pe-[var(--removed-body-scroll-bar-size,0px)]"
    >
      <div className="container-fluid grow flex items-stretch justify-between gap-2.5">
        <div className="flex items-stretch">
          <HeaderLogo />
        </div>
        <HeaderSearch />
      </div>
    </header>
  );
}
